

import { useContext } from 'react';
import { DataContext } from '../data/DataContext';
import { RadioButton, Input, InputFile, VehiclesInvolvedCtrl } from '../components'
import { catSiNo } from '../data/MochaData'
import { getDefaultVehiclesInvolved } from '../data/Help';


const Step5 = () => {
    const { ReclamosInspeccionNI, setReclamosInspeccionNI, changeHandler } = useContext(DataContext);
    const changeRadio = (propierties: string, value: boolean) => setReclamosInspeccionNI({ ...ReclamosInspeccionNI, [propierties]: value });
    const changeFiles = (propierties: string, files: Array<File>, isMod: boolean) => setReclamosInspeccionNI({ ...ReclamosInspeccionNI, [propierties]: files, [`${propierties}IsModified`]: isMod });

    const addVehiclesInvolved = (e: any) => {
        e.preventDefault();
        let max = ReclamosInspeccionNI.vehiclesInvolved?.sort((a: IVehiclesInvolved, b: IVehiclesInvolved) => (a.id - b.id));
        if (max !== undefined && max?.length > 0) {
            let dataNew: IVehiclesInvolved = getDefaultVehiclesInvolved();
            dataNew.id = max[max.length - 1].id + 1;
            max.push(dataNew);
            setReclamosInspeccionNI({ ...ReclamosInspeccionNI, vehiclesInvolved: max });
        }
    }

    return (
        <>
            <RadioButton
                label='¿Hubo otro(s) vehículo involucrado(s)?*'
                field={'isVehiclesInvolved'}
                key={'isVehiclesInvolved'}
                value={ReclamosInspeccionNI.isVehiclesInvolved}
                onChange={changeRadio}
                catalog={catSiNo}
            />
            {ReclamosInspeccionNI.isVehiclesInvolved === 'S' && <>
                {ReclamosInspeccionNI.vehiclesInvolved?.map((x: IVehiclesInvolved) => {
                    return <VehiclesInvolvedCtrl data={x} onChage={() => { }} />
                })}
                <div className='mt-10' style={{ display: 'flex' }}>
                    <button className='btn-add-re-ni' onClick={addVehiclesInvolved}> + </button>
                    <div className='ml-10 lbl-input-re-ni'>
                        Pulsá aquí para agregar más autos involucrados
                    </div>
                </div>
            </>
            }


            <RadioButton
                label='¿Hubo propiedad(es) de terceros dañada?*'
                field={'isDamagedThirdPartyProperty'}
                key={'isDamagedThirdPartyProperty'}
                value={ReclamosInspeccionNI.isDamagedThirdPartyProperty}
                onChange={changeRadio}
                catalog={catSiNo}
            />
            {ReclamosInspeccionNI.isDamagedThirdPartyProperty === 'S' &&
                <>
                    <Input
                        id='damageDetail'
                        field='damageDetail'
                        onChange={changeHandler}
                        label='Detalle de los daños causados a la propiedad*'
                        value={ReclamosInspeccionNI.damageDetail}
                        type='textarea'
                        placeholder='Indicar si hubo daño a paredes, portones de casas, propiedad pública, etc.'
                    />
                    <InputFile
                        id='imageDamageDetail'
                        label='Toma fotografías a la propiedad de terceros dañada'
                        files={ReclamosInspeccionNI.imageDamageDetail}
                        onChange={changeFiles}
                        isRequired={false}
                    />
                </>
            }
            <RadioButton
                label='¿Hubieron personas lesionadas?*'
                field={'isInjuredPeople'}
                key={'isInjuredPeople'}
                value={ReclamosInspeccionNI.isInjuredPeople}
                onChange={changeRadio}
                catalog={catSiNo}
            />

            {ReclamosInspeccionNI.isInjuredPeople === 'S' && <>
                <Input
                    id='numberInjured'
                    field='numberInjured'
                    onChange={changeHandler}
                    label='¿Cuantos lesionados hubo?*'
                    value={ReclamosInspeccionNI.numberInjured}
                    type='number'
                    placeholder='Indicar cuantos lesionados en cantidad'
                />
                <Input
                    id='healthUnitWereTransferred'
                    field='healthUnitWereTransferred'
                    onChange={changeHandler}
                    label='En caso que aplique, ¿a qué unidad de salud fueron trasladados?'
                    value={ReclamosInspeccionNI.healthUnitWereTransferred}
                    type='textarea'
                    placeholder='Indicar el nombre de la unidad de salud u hospital'
                    isRequired={false}
                />
            </>
            }

            <RadioButton
                label='¿Hubieron personas fallecidas?*'
                field={'HuboPersonasFallecidas'}
                key={'HuboPersonasFallecidas'}
                value={ReclamosInspeccionNI.HuboPersonasFallecidas}
                onChange={changeRadio}
                catalog={catSiNo}
                isRequired={true}
            />

            {ReclamosInspeccionNI.HuboPersonasFallecidas === 'S' && <>
                <Input
                    id='CantidadPersonasFallecidas'
                    field='CantidadPersonasFallecidas'
                    onChange={changeHandler}
                    label='¿Cuántos fallecidos hubo?*'
                    value={ReclamosInspeccionNI.CantidadPersonasFallecidas}
                    type='number'
                    placeholder='Indicar cuantos fallecidos hubo'
                />
            </>
            }
        </>
    )
}

export { Step5 }